class ScrollProgress extends HTMLElement {
  constructor() {
    super();
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    // Page height changes as images/sections load in, which changes the max scroll
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.onScroll);
      this.observer.observe(document.documentElement);
    }

    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.observer) this.observer.disconnect();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;

    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const progress = maxScroll > 0 ? Math.min(Math.max(window.scrollY / maxScroll, 0), 1) : 0;

    this.style.setProperty('--scroll-progress', progress);
    this.classList.toggle('scroll-progress--visible', progress > 0.001);
  }
}

if (!customElements.get('scroll-progress')) {
  customElements.define('scroll-progress', ScrollProgress);
}
